import { LogbookSettingsState, MESFMain, themeMESF } from "@dexteel/mesf-core";
import { ThemeProvider as StylesThemeProvider } from "@mui/styles";
import { createTheme } from "@mui/material/styles";
import "react-datepicker/dist/react-datepicker.css";
import { render } from "react-dom";
import "./app.css";
import "./setup/ag-grid";

import { AuthenticationConfig } from "./setup/auth-config";
import { customConfigurations } from "./setup/configurations";
import { CustomNavbar } from "./setup/navbar";
import { CustomRoutes } from "./setup/routes";
import { fabPalette } from "./setup/theme/fab-palette";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "./setup/nprogress";

const muiTheme = createTheme({
	palette: {
		mode: "light",
		primary: fabPalette.primary,
		secondary: fabPalette.secondary,
	},
});

themeMESF.palette = {
	...themeMESF.palette,
	mode: "light",
	primary: fabPalette.primary,
	secondary: fabPalette.secondary,
};

const logbookSettings = {
	entry: {
		allowAttachments: true,
		exportToExcel: true,
		presetAssetId: 12,
	},
	report: {
		showAttachments: true,
		exportToExcel: true,
	},
} as Partial<LogbookSettingsState>;

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
			cacheTime: 1000 * 60,
		},
	},
});

render(
	<StylesThemeProvider theme={muiTheme}>
		<QueryClientProvider client={queryClient}>
			<MESFMain
				showAreaSelector={true}
				routes={CustomRoutes}
				navbarTitle={"SWV FAB"}
				navbar={CustomNavbar}
				authentication={AuthenticationConfig}
				configurations={customConfigurations}
				logbookSettings={logbookSettings}
			/>
		</QueryClientProvider>
	</StylesThemeProvider>,
	document.getElementById("root"),
);
